'use client';
import { useState } from 'react';
import { useTranslations, useLocale } from 'next-intl';

export default function ContactPage() {
  const locale = useLocale();
  const [form, setForm] = useState({ name: '', email: '', message: '' });
  const [sent, setSent] = useState(false);

  const labels = {
    en: { title: 'Contact Us', name: 'Your Name', email: 'Email Address', message: 'Message', send: 'Send Message', sent: 'Thank you! We will get back to you soon.', info: 'You can also reach us at:' },
    es: { title: 'Contáctanos', name: 'Tu Nombre', email: 'Correo Electrónico', message: 'Mensaje', send: 'Enviar Mensaje', sent: '¡Gracias! Te responderemos pronto.', info: 'También puedes contactarnos en:' },
    de: { title: 'Kontakt', name: 'Ihr Name', email: 'E-Mail-Adresse', message: 'Nachricht', send: 'Nachricht Senden', sent: 'Vielen Dank! Wir werden uns bald bei Ihnen melden.', info: 'Sie können uns auch erreichen unter:' },
    fr: { title: 'Contactez-nous', name: 'Votre Nom', email: 'Adresse E-mail', message: 'Message', send: 'Envoyer', sent: 'Merci ! Nous vous répondrons bientôt.', info: 'Vous pouvez également nous contacter à :' },
  };
  const l = labels[locale] || labels.en;

  const handleSubmit = (e) => { e.preventDefault(); setSent(true); };

  return (
    <div style={{ maxWidth: 700, margin: '0 auto', padding: '60px 20px', minHeight: '60vh' }}>
      <h1 style={{ fontSize: '2rem', fontWeight: 800, marginBottom: 30, color: '#3f3f47' }}>{l.title}</h1>
      {sent ? (
        <div style={{ padding: 40, background: '#e8f5e9', borderRadius: 12, textAlign: 'center', fontSize: 18, color: '#2e7d32' }}>{l.sent}</div>
      ) : (
        <form onSubmit={handleSubmit} style={{ display: 'flex', flexDirection: 'column', gap: 20 }}>
          <input type="text" placeholder={l.name} required value={form.name} onChange={e => setForm({...form, name: e.target.value})}
            style={{ padding: '14px 16px', border: '1px solid #ddd', borderRadius: 8, fontSize: 16 }} />
          <input type="email" placeholder={l.email} required value={form.email} onChange={e => setForm({...form, email: e.target.value})}
            style={{ padding: '14px 16px', border: '1px solid #ddd', borderRadius: 8, fontSize: 16 }} />
          <textarea placeholder={l.message} required rows={6} value={form.message} onChange={e => setForm({...form, message: e.target.value})}
            style={{ padding: '14px 16px', border: '1px solid #ddd', borderRadius: 8, fontSize: 16, resize: 'vertical' }} />
          <button type="submit" style={{ padding: '14px', background: '#96b23c', color: 'white', border: 'none', borderRadius: 8, fontSize: 16, fontWeight: 600, cursor: 'pointer' }}>{l.send}</button>
        </form>
      )}
      <div style={{ marginTop: 40, padding: 24, background: '#f9f9f9', borderRadius: 12 }}>
        <p style={{ fontWeight: 600, marginBottom: 12 }}>{l.info}</p>
        <p>📧 info@gurrex.es</p>
      </div>
    </div>
  );
}
